// ============================================================
// HABIT OS — Bibliotheks-Index (aktualisiert)
// Führt alle Einzel-Bibliotheken zusammen.
// ============================================================

import { LIBRARY_HEALTH }              from "./libraryHealth";
import { LIBRARY_GUT_HEALTH }          from "./libraryGutHealth";
import { LIBRARY_SKINCARE }            from "./librarySkincare";
import { LIBRARY_HAIR }                from "./libraryHair";
import { LIBRARY_RECIPES }             from "./libraryRecipes";
import { LIBRARY_LONGEVITY }           from "./libraryLongevity";
import { LIBRARY_ELECTROLYTES }        from "./libraryElectrolytes";
import { LIBRARY_PROTEIN }             from "./libraryProtein";
import { LIBRARY_SUPPLEMENTS }         from "./librarySupplements";
import { LIBRARY_SLEEP_OPTIMIZATION }  from "./librarySleepOptimization";
import { LIBRARY_COLD_THERAPY }        from "./libraryColdTherapy";
import { LIBRARY_LIGHT_PROTOCOLS }     from "./libraryLightProtocols";
import { LIBRARY_SPORT, LIBRARY_MIND, LIBRARY_FOOD } from "./libraryOthers";

export const HABIT_LIBRARY = [
  LIBRARY_HEALTH,
  LIBRARY_SUPPLEMENTS,
  LIBRARY_SLEEP_OPTIMIZATION,
  LIBRARY_COLD_THERAPY,
  LIBRARY_LIGHT_PROTOCOLS,
  LIBRARY_GUT_HEALTH,
  LIBRARY_ELECTROLYTES,
  LIBRARY_PROTEIN,
  LIBRARY_SKINCARE,
  LIBRARY_HAIR,
  LIBRARY_RECIPES,
  LIBRARY_LONGEVITY,
  LIBRARY_SPORT,
  LIBRARY_MIND,
  LIBRARY_FOOD,
];

// ─────────────────────────────────────────────
// HELPER FUNCTIONS
// ─────────────────────────────────────────────

export function getAllHabits() {
  return HABIT_LIBRARY.flatMap((cat) =>
    cat.subcategories.flatMap((sub) =>
      sub.habits.map((h) => ({
        ...h,
        categoryId:       cat.id,
        categoryLabel:    cat.label,
        categoryIcon:     cat.icon,
        subcategoryId:    sub.id,
        subcategoryLabel: sub.label,
      }))
    )
  );
}

export function getHabitById(id) {
  return getAllHabits().find((h) => h.id === id);
}

export function getHabitsByCategory(categoryId) {
  const cat = HABIT_LIBRARY.find((c) => c.id === categoryId);
  return cat ? cat.subcategories.flatMap((s) => s.habits) : [];
}

export function searchHabits(query) {
  const q = query.toLowerCase();
  return getAllHabits().filter(
    (h) =>
      h.label.toLowerCase().includes(q) ||
      h.why.toLowerCase().includes(q) ||
      h.categoryLabel.toLowerCase().includes(q) ||
      h.subcategoryLabel.toLowerCase().includes(q)
  );
}